<style scoped>
p {
  margin: 5px 0;
}
.title {
  font-size: 1.25rem;
  font-weight: bolder;
}
.sub-title {
  font-size: 1rem;
  font-weight: bolder;
}
.total {
  font-size: 2.25rem;
  font-weight: 600;
}
.confirmation {
  font-size: 1rem;
  font-weight: bolder;
}
.bg-primary {
  background-color: #4285f4 !important;
}

.bg-warning {
  background-color: #ffbb33 !important;
}

.bg-success {
  background-color: #00c851 !important;
}

.bg-danger {
  background-color: #ff646c !important;
}
</style>
<template>
  <b-container fluid class="content landing-page">
    <b-breadcrumb :items="breadcrumbs" class="breadcrumbs"></b-breadcrumb>
    <b-container fluid>
      <title-page
        :title="'Monitoring Ground Check Anomali'"
        :subtitle="'Monitoring uji coba ground check anomali satu data kependudukan Indonesia.'"
      />
      <b-row>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation v-model="kodeProv" name="Provinsi">
            <option value="">Pilih Provinsi</option>
            <option
              v-for="item in provinsis"
              :value="item.kode_prov"
              v-bind:key="item.kode_prov"
            >
              {{ item.nama_prov }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation v-model="kodeKab" name="Kabupaten/Kota">
            <option value="">Pilih Kabupaten/Kota</option>
            <option
              v-for="item in kabupatenKotas"
              :value="item.kode_kab"
              v-bind:key="item.kode_kab"
            >
              {{ item.nama_kab }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="2" md="6" sm="12">
          <BSelectWithValidation v-model="kodeKec" name="Kecamatan">
            <option value="">Pilih Kecamatan</option>
            <option
              v-for="item in kecamatans"
              :value="item.kode_kec"
              v-bind:key="item.kode_kec"
            >
              {{ item.nama_kec }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="3" md="6" sm="12">
          <BSelectWithValidation v-model="kodeDesa" name="Desa/Kelurahan">
            <option value="">Pilih Desa/Kelurahan</option>
            <option
              v-for="item in desaKelurahans"
              :value="item.kode_desa"
              v-bind:key="item.kode_desa"
            >
              {{ item.nama_desa }}
            </option>
          </BSelectWithValidation>
        </b-col>
        <b-col lg="3" md="6" sm="12">
          <BSelectWithValidation
            v-model="kodeSls"
            name="Satuan Lingkungan Setempat"
          >
            <option value="">Pilih Satuan Lingkungan Setempat</option>
            <option
              v-for="item in satuanLingkunganSetempats"
              :value="item.kode_sls"
              v-bind:key="item.kode_sls"
            >
              {{ item.nama_sls }}
            </option>
          </BSelectWithValidation>
        </b-col>
      </b-row>
      <b-tabs fill>
        <b-tab title="Anomali" active>
          <legend>Total Anomali</legend>
          <b-row>
            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="warning" text-variant="white">
                <p class="title">Anomali Tipe 1</p>
                <p class="sub-title">NIK Tidak Valid</p>
                <p>
                  <span class="total">{{ sumAnomali("rule1") }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="success" text-variant="white">
                <p class="title">Anomali Tipe 2</p>
                <p class="sub-title">KK Tidak Valid</p>
                <p>
                  <span class="total">{{ sumAnomali("rule2") }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="danger" text-variant="white">
                <p class="title">Anomali Tipe 3</p>
                <p class="sub-title">Perbedaan Alamat</p>
                <p>
                  <span class="total">{{ sumAnomali("rule3") }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="primary" text-variant="white">
                <p class="title">Anomali Tipe 4</p>
                <p class="sub-title">Perbedaan Jenis Kelamin</p>
                <p>
                  <span class="total">{{ sumAnomali("rule4") }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="success" text-variant="white">
                <p class="title">Anomali Tipe 5</p>
                <p class="sub-title">Kepala Keluarga Kurang Dari 11 Tahun</p>
                <p>
                  <span class="total">{{ sumAnomali("rule5") }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="danger" text-variant="white">
                <p class="title">Anomali Tipe 6</p>
                <p class="sub-title">Status Bukan Kepala Keluarga (1 ART)</p>
                <p>
                  <span class="total">{{ sumAnomali("rule6") }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="primary" text-variant="white">
                <p class="title">Anomali Tipe 7</p>
                <p class="sub-title">Sumber Data Perlu Konfirmasi</p>
                <p>
                  <span class="total">{{ sumAnomali("rule7") }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
          <legend class="mt-4">Total Anomali Berdasarkan Wilayah</legend>
          <div class="table-responsive">
            <b-table
              class="table table-primary"
              :items="dashboardAnomaliDataGroup"
              :fields="detailFields"
            >
              <template v-slot:cell(no)="data">
                {{ data.index + 1 }}.
              </template>
            </b-table>
          </div>
        </b-tab>
        <b-tab title="Konfirmasi">
          <legend>
            Total Data Hasil Ground Check Berdasarkan Status Keberadaan
          </legend>
          <b-row>
            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="warning" text-variant="white">
                <p class="title">Ditemukan</p>
                <p>
                  <span class="total">{{ sumKeberadaan().ditemukan }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="success" text-variant="white">
                <p class="title">Tidak Ditemukan</p>
                <p>
                  <span class="total">{{
                    sumKeberadaan().tidakDitemukan
                  }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="danger" text-variant="white">
                <p class="title">Pindah</p>
                <p>
                  <span class="total">{{ sumKeberadaan().pindah }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="primary" text-variant="white">
                <p class="title">Meninggal</p>
                <p>
                  <span class="total">{{ sumKeberadaan().meninggal }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
          <legend class="mt-4">
            Total Perubahan Data Berdasarkan Variabel
          </legend>
          <b-row>
            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="warning" text-variant="white">
                <p class="title">Nama</p>
                <p>
                  <span class="total">{{ sumPerubahan().nama }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="success" text-variant="white">
                <p class="title">NIK</p>
                <p>
                  <span class="total">{{ sumPerubahan().nik }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="danger" text-variant="white">
                <p class="title">Nomor KK</p>
                <p>
                  <span class="total">{{ sumPerubahan().nomor_kk }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="primary" text-variant="white">
                <p class="title">Jenis Kelamin</p>
                <p>
                  <span class="total">{{ sumPerubahan().tanggal_lahir }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="warning" text-variant="white">
                <p class="title">Tanggal Lahir</p>
                <p>
                  <span class="total">{{ sumPerubahan().tanggal_lahir }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="success" text-variant="white">
                <p class="title">Agama</p>
                <p>
                  <span class="total">{{ sumPerubahan().agama }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="danger" text-variant="white">
                <p class="title">Pendidikan</p>
                <p>
                  <span class="total">{{ sumPerubahan().pendidikan }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="3" md="6" sm="12">
              <b-card bg-variant="primary" text-variant="white">
                <p class="title">Pekerjaan</p>
                <p>
                  <span class="total">{{ sumPerubahan().pekerjaan }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="success" text-variant="white">
                <p class="title">Status Pernikahan</p>
                <p>
                  <span class="total">{{ sumPerubahan().status_kawin }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="danger" text-variant="white">
                <p class="title">Status Hubungan Keluarga</p>
                <p>
                  <span class="total">{{
                    sumPerubahan().status_hubungan_keluarga
                  }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="primary" text-variant="white">
                <p class="title">Kewarganegaraan</p>
                <p>
                  <span class="total">{{
                    sumPerubahan().kewarganegaraan
                  }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
          <legend class="mt-4">Total Penduduk Baru Hasil Ground Check</legend>
          <b-row>
            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="success" text-variant="white">
                <p class="title">Laki-laki</p>
                <p>
                  <span class="total">{{ sumPendudukBaru().lakiLaki }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="danger" text-variant="white">
                <p class="title">Perempuan</p>
                <p>
                  <span class="total">{{ sumPendudukBaru().perempuan }}</span>
                </p>
              </b-card>
            </b-col>

            <b-col lg="4" md="6" sm="12">
              <b-card bg-variant="primary" text-variant="white">
                <p class="title">Total</p>
                <p>
                  <span class="total">{{ sumPendudukBaru().total }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-container>
  </b-container>
</template>
<script>
import titlePage from "@/components/Title";
import dashboardAnomaliService from "../../../services/sdpi/DashboardAnomaliService";
import dashboardKeberadaanService from "../../../services/sdpi/DashboardKeberadaanService";
import dashboardPerubahanService from "../../../services/sdpi/DashboardPerubahanService";
import dashboardPendudukBaruService from "../../../services/sdpi/DashboardPendudukBaruService";
import masterWilayahService from "../../../services/sdpi/MasterWilayahService";
import BSelectWithValidation from "@/components/inputs/BSelectWithValidation";
export default {
  components: { titlePage, BSelectWithValidation },
  data: () => {
    return {
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sdpi",
        },
        {
          text: "Monitoring dan Evaluasi",
          active: true,
        },
      ],
      dashboardAnomaliData: [],
      dashboardAnomaliDataGroup: [],
      dashboardKeberadaanData: [],
      dashboardPerubahanData: [],
      dashboardPendudukBaruData: [],
      provinsis: [],
      kodeProv: "",
      kabupatenKotas: [],
      kodeKab: "",
      kecamatans: [],
      kodeKec: "",
      desaKelurahans: [],
      kodeDesa: "",
      satuanLingkunganSetempats: [],
      kodeSls: "",
      detailFields: [
        "no",
        {
          label: "Nama Wilayah",
          key: "nama",
        },
        {
          label: "Anomali Tipe 1",
          key: "rule1",
        },
        {
          label: "Anomali Tipe 2",
          key: "rule2",
        },
        {
          label: "Anomali Tipe 3",
          key: "rule3",
        },
        {
          label: "Anomali Tipe 4",
          key: "rule4",
        },
        {
          label: "Anomali Tipe 5",
          key: "rule5",
        },
        {
          label: "Anomali Tipe 6",
          key: "rule6",
        },
        {
          label: "Anomali Tipe 7",
          key: "rule7",
        },
      ],
    };
  },
  methods: {
    async getAnomaliDatas(param) {
      await dashboardAnomaliService.getData(param).then(
        (result) => {
          // this.getAnomaliDataGroups(param);
          this.getKeberadaanDatas(param);
          this.dashboardAnomaliData = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getAnomaliDataGroups(param) {
      await dashboardAnomaliService.getDataGroup(param).then(
        (result) => {
          this.dashboardAnomaliDataGroup = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKeberadaanDatas(param) {
      await dashboardKeberadaanService.getData(param).then(
        (result) => {
          this.getPerubahanDatas(param);
          this.dashboardKeberadaanData = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getPerubahanDatas(param) {
      await dashboardPerubahanService.getData(param).then(
        (result) => {
          this.getPendudukBaruDatas(param);
          this.dashboardPerubahanData = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getPendudukBaruDatas(param) {
      await dashboardPendudukBaruService.getData(param).then(
        (result) => {
          this.dashboardPendudukBaruData = result.data.data;
          console.log(this.dashboardPendudukBaruData.length);
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getProvinsi() {
      await masterWilayahService.getProvinsi().then(
        (result) => {
          this.provinsis = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKabupatenKota(id) {
      await masterWilayahService.getKabupatenKotaByProvinsi(id).then(
        (result) => {
          this.kabupatenKotas = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getKecamatan(id) {
      await masterWilayahService.getKecamatanByKabupatenKota(id).then(
        (result) => {
          this.kecamatans = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getDesaKelurahan(id) {
      await masterWilayahService.getDesaKelurahanByKecamatan(id).then(
        (result) => {
          this.desaKelurahans = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    async getSls(id) {
      await masterWilayahService.getSlsByDesa(id).then(
        (result) => {
          this.satuanLingkunganSetempats = result.data.data;
        },

        (error) => {
          console.log(error);
        }
      );
    },
    sumAnomali(key) {
      let data = 0;
      let i = 0;
      for (i; i < this.dashboardAnomaliData.length; i++) {
        data += parseInt(this.dashboardAnomaliData[i][key]);
      }
      return data.toLocaleString("id-ID");
    },
    sumKeberadaan() {
      let data = { ditemukan: 0, tidakDitemukan: 0, pindah: 0, meninggal: 0 };
      let i = 0;
      for (i; i < this.dashboardKeberadaanData.length; i++) {
        if (this.dashboardKeberadaanData[i].status_keberadaan == "1") {
          data.ditemukan += parseInt(this.dashboardKeberadaanData[i].total);
        } else if (this.dashboardKeberadaanData[i].status_keberadaan == "2") {
          data.tidakDitemukan += parseInt(
            this.dashboardKeberadaanData[i].total
          );
        } else if (this.dashboardKeberadaanData[i].status_keberadaan == "3") {
          data.pindah += parseInt(this.dashboardKeberadaanData[i].total);
        } else if (this.dashboardKeberadaanData[i].status_keberadaan == "4") {
          data.meninggal += parseInt(this.dashboardKeberadaanData[i].total);
        }
      }
      return data;
    },
    sumPerubahan() {
      let data = {
        agama: 0,
        nama: 0,
        jenis_kelamin: 0,
        nik: 0,
        nomor_kk: 0,
        pekerjaan: 0,
        pendidikan: 0,
        status_kawin: 0,
        tanggal_lahir: 0,
        status_hubungan_keluarga: 0,
        kewarganegaraan: 0,
      };
      let i = 0;
      for (i; i < this.dashboardPerubahanData.length; i++) {
        data.nama += parseInt(this.dashboardPerubahanData[i].nama);
        data.agama += parseInt(this.dashboardPerubahanData[i].agama);
        data.jenis_kelamin += parseInt(
          this.dashboardPerubahanData[i].jenis_kelamin
        );
        data.nik += parseInt(this.dashboardPerubahanData[i].nik);
        data.nomor_kk += parseInt(this.dashboardPerubahanData[i].nomor_kk);
        data.pekerjaan += parseInt(this.dashboardPerubahanData[i].pekerjaan);
        data.pendidikan += parseInt(this.dashboardPerubahanData[i].pendidikan);
        data.status_kawin += parseInt(
          this.dashboardPerubahanData[i].status_kawin
        );
        data.tanggal_lahir += parseInt(
          this.dashboardPerubahanData[i].tanggal_lahir
        );
        data.status_hubungan_keluarga += parseInt(
          this.dashboardPerubahanData[i].status_hubungan_keluarga
        );
        data.kewarganegaraan += parseInt(
          this.dashboardPerubahanData[i].kewarganegaraan
        );
      }
      return data;
    },
    sumPendudukBaru() {
      let data = { lakiLaki: 0, perempuan: 0, total: 0 };
      let i = 0;
      for (i; i < this.dashboardPendudukBaruData.length; i++) {
        if (this.dashboardPendudukBaruData[i].jenis_kelamin == "L") {
          data.lakiLaki += parseInt(this.dashboardPendudukBaruData[i].total);
          data.total += parseInt(this.dashboardPendudukBaruData[i].total);
        } else if (this.dashboardPendudukBaruData[i].jenis_kelamin == "P") {
          data.perempuan += parseInt(this.dashboardPendudukBaruData[i].total);
          data.total += parseInt(this.dashboardPendudukBaruData[i].total);
        }
      }
      return data;
    },
  },
  mounted() {
    this.getAnomaliDatas(null);
    this.getProvinsi();
  },
  watch: {
    kodeProv(val) {
      if (val) {
        this.kodeKab = "";
        this.kodeKec = "";
        this.kodeDesa = "";
        this.kodeSls = "";
        this.getAnomaliDatas("?kode_prov=" + val);
        this.getKabupatenKota(val);
      }
    },
    kodeKab(val) {
      if (val) {
        this.kodeKec = "";
        this.kodeDesa = "";
        this.kodeSls = "";
        this.getAnomaliDatas("?kode_kab=" + val);
        this.getKecamatan(val);
      }
    },
    kodeKec(val) {
      if (val) {
        this.kodeDesa = "";
        this.kodeSls = "";
        this.getAnomaliDatas("?kode_kec=" + val);
        this.getDesaKelurahan(val);
      }
    },
    kodeDesa(val) {
      if (val) {
        this.kodeSls = "";
        this.getAnomaliDatas("?kode_desa=" + val);
        this.getSls(val);
      }
    },
    kodeSls(val) {
      if (val) {
        this.getAnomaliDatas("?kode_sls=" + val);
      }
    },
  },
};
</script>
